var zhCN = {
  locale: 'zh_CN',
  direction: 'ltr',
  date: {
    defaultFormat: {
      week: 'YYYY-WW',
      date: 'YYYY-MM-DD',
      month: 'YYYY-MM',
      year: 'YYYY',
      time: 'HH:mm:ss',
      dateTime: 'YYYY-MM-DD HH:mm:ss'
    },
    startDay: 1,
    monthList: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
    shortMonthList: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    dayList: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
    shortDayList: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
    shortestDayList: ['日', '一', '二', '三', '四', '五', '六']
  },
  'dynamic-date': {
    day: '天',
    week: '周',
    month: '月',
    quarter: '季度',
    year: '年',
    before: '${value}${unit}前'
  },
  'auto-complete.placeholder': '请选择',
  'auto-complete.empty': '暂无数据',
  'cascader.titles': ['一级', '二级', '三级', '四级', '五级', '六级', '七级', '八级'],
  'cascader.empty': '暂无数据',
  'cascader.search': '请输入搜索词',
  'color.custom': '自定义颜色',
  'date.year': '${year}年',
  'date.month': '月',
  'date.week': '周',
  'date.month-first': false,
  'date-picker.start': '开始时间',
  'date-picker.end': '结束时间',
  'date-picker.placeholder': '请选择日期',
  'date-picker.cancel': '取消',
  'date-picker.apply': '应用',
  'date-picker.invalid-range': '您选择的时间范围已超出可选范围，请调整',
  'date-comparison.mom': '环比上一时间段',
  'date-comparison.yoy': '去年该时段',
  'date-comparison.placeholder': '开始时间 ~ 结束时间',
  'date-comparison.error-source': '请选择对比的起始时间',
  'date-comparison.error-target': '请选择对比的结束时间',
  'date-comparison.compare': '对比',
  'date-comparison.compare-text': '对比',
  'dynamic-date.customize': '自定义',
  'dynamic-date.date-preview': '时间预览',
  'dynamic-date.dynamic-date': '动态时间',
  'dynamic-date.interval': '时间单位',
  'dynamic-date.fixed-date': '固定时间',
  'empty.text': '暂无数据',
  'input.placeholder': '请输入',
  'textarea.placeholder': '请输入',
  'list-viewer.empty': '暂无数据',
  'modal.cancel': '取消',
  'modal.ok': '确定',
  'pager.jump': '跳转',
  'pager.total': '共${total}条记录',
  'pager.size': '${count}条/页',
  'pager.page.placeholder': '请输入',
  'popover.cancel': '取消',
  'popover.ok': '确定',
  'schedule.selected': '已选择时间',
  'schedule.clear': '清空',
  'schedule.separator': '、',
  'schedule.title': '日期/时间',
  'select.search.placeholder': '请输入',
  'select.empty': '暂无数据',
  'select.selected': '已选',
  'select.selected-count': '已选${count}项',
  'select.select-all': '全选',
  'select.placeholder': '请选择',
  'select.clear': '清空',
  'tabs.more': '更多',
  'table.emptyText': '内容为空',
  'table.filter.reset': '重置',
  'table.filter.confirm': '确定',
  'transfer.empty': '暂无相关数据',
  'transfer.placeholder': '请输入',
  'transfer.source': '源列表',
  'transfer.target': '目标列表',
  'tree.empty': '没找到相关结果',
  'tree-select.placeholder': '请输入',
  'tree-select.empty': '暂无数据',
  'time-picker.placeholder': '请选择时间',
  'time-range-picker.placeholder': '开始时间 ～ 结束时间',
  'upload.error.overflow-count': '超出最大文件数量限制',
  'upload.click': '点击上传',
  'upload.drop': '将文件拖到此处，或',
  'date-time-picker.now': '此刻',
  'date-time-picker.ok': '确定',
  'date-time-picker.date': '选择日期',
  'date-time-picker.time': '选择时间',
  'date-time-picker.placeholder': '请输入',
  'date-time-picker.start': '选择开始日期时间',
  'date-time-picker.end': '选择结束日期时间',
  'image-view.next': '下一张',
  'image-view.prev': '上一张',
  'image-view.zoom-in': '放大',
  'image-view.zoom-out': '缩小',
  'image-view.zoom-to-origin': '原始尺寸',
  'image-view.zoom-to-fit': '适配',
  'image-view.rotate': '旋转'
};
export default zhCN;